import moment from "moment";
import { FormValidationRule } from "../../forms/types";
import { parseDateFormat } from "../../forms/helper";

const maxAge: FormValidationRule = (c, v) => {
    let valid = true;
    let message = "";

    if (c.field_boi_maximum_age && v) {
        const value = moment(v, "YYYY-MM-DD");
        const today = moment().startOf("day");
        const max = today.clone().add(-parseInt(c.field_boi_maximum_age), "years");
        const dateFormat = c.dateFormat || "dmy";

        if (value.isBefore(max)) {
            valid = false;
            message = `Date must be after ${max.format(
                parseDateFormat(dateFormat).toUpperCase()
            )}.`;
        } else if (value.isAfter(today)) {
            valid = false;
            message = `Date must be before ${today.format(
                parseDateFormat(dateFormat).toUpperCase()
            )}.`;
        }
    }
    return [valid, message];
};

export default maxAge;
